export default __webpack_public_path__ + "static/media/CERTIFICADO-MINICURSO-CARDIOLOGICAS.3b032078.svg";